import type {
  AssetKind,
  AssetView,
  StorageUsage,
  UploadIntent,
} from '@alterium/shared';
import { api, apiRequestWithMeta } from './client';

export const assetsApi = {
  media: (params: { cursor?: string; kind?: AssetKind } = {}) =>
    apiRequestWithMeta<AssetView[]>({
      method: 'GET',
      url: '/media',
      params: { limit: 24, ...params },
    }),

  get: (id: string) => api.get<AssetView>(`/assets/${id}`),
  usage: () => api.get<StorageUsage>('/assets/usage'),

  uploadIntent: (input: {
    kind: AssetKind;
    mime: string;
    bytes: number;
    checksum: string;
    originalName?: string;
  }) => api.post<UploadIntent>('/assets/upload-intent', input),

  complete: (id: string) => api.post<AssetView>(`/assets/${id}/complete`),
  remove: (id: string) => api.delete(`/assets/${id}`),
  downloadUrl: (id: string) => api.get<{ url: string }>(`/assets/${id}/download`),
};
